import { Waypoint }   from "react-waypoint";
import { useRouter }  from "next/router";
import { storeEvent } from "_analytics/index";
import Loader         from "_components/atoms/loader";

const component = props => {
	const {
		isFetchingData,
		isDataDepleted,
		fetchData,
		fetchDataParams,
		index,
		currentListLength,
		fetchOffset,
		tabType, /* from UserProfile Feeds for GA events logging  */
		homeFeedTypeForGA, /* from Home Page VerticalFeed for GA events logging  */
		pageSource,
		step
	} = props;

	const router = useRouter ();

	return (
		<>
			{ isFetchingData && !isDataDepleted && index === currentListLength - 1 && <Loader /> }

			{
				!isDataDepleted && !isFetchingData && currentListLength > 0 && index === currentListLength - fetchOffset && (
					<Waypoint
						onEnter = { () => {
							( tabType === "videoFeed" || tabType === "broadcastFeed" ) && storeEvent ( "Scrolled", tabType === "videoFeed" ? "Videos" : "Broadcast", "Profile" );
							if ( router.route === "/[explore]" && homeFeedTypeForGA === "VIDEOS" )
								storeEvent ( "Scrolled", "Video", "Videos" );
							if ( router.route === "/[explore]" && pageSource === "GIVEAWAYS" )
								storeEvent ( "Scrolled", "Broadcast", "Giveaway_Videos" );
							if ( router.route === "/[explore]" && pageSource === "FEATURED" )
								storeEvent ( "Scrolled", "Broadcast", "Featured_Videos" );
							if ( router.route === "/[explore]" && pageSource === "FEATURED" )
								storeEvent ( "Scrolled", "Broadcast", "Featured_Videos" );
							if ( step === 3 )
								storeEvent ( "Scrolled", "Broadcast", "Game_Card" );
							if ( step === 2 )
								storeEvent ( "Scrolled", "Broadcast", "Live_Gaming" );
							if ( step === 1 )
								storeEvent ( "Scrolled", "Broadcast", "Trending_Live" );
							if ( router.route === "/" && homeFeedTypeForGA === "TRENDING" )
								storeEvent ( "Scrolled", "Broadcast", "Trending" );
							if ( router.route === "/" && homeFeedTypeForGA === "GIVEAWAYS" )
								storeEvent ( "Scrolled", "Broadcast", "Giveaways" );
							if ( router.route === "/" && homeFeedTypeForGA === "FEATURED" )
								storeEvent ( "Scrolled", "Broadcast", "Featured" );
							fetchData ( fetchDataParams );
						} }
					/>
				)
			}
		</>
	);
};

export default component;
